<template>
    <div id="edit-license" v-bind:class="[mode === 'add' || mode==='add-new-project' || mode==='add-new-or-connect-project' ? 'add' : 'edit','modal inmodal']" role="dialog"
         aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-l modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title add" v-if="mode === 'add'">{{ t_new }}</h2>
                    <h2 class="modal-title add" v-if="mode === 'add-new-project'">{{ t_new_project }}</h2>
                    <h2 class="modal-title add" v-if="mode === 'add-new-or-connect-project'">{{ t_new_or_connect_project }}</h2>
                    <h2 class="modal-title edit" v-if="mode === 'delete'">{{ t_remove }}</h2>
                </div>
                <div v-if="mode==='add' || mode==='add-new-project' || mode==='add-new-or-connect-project'" class="modal-body text-center scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <div :class="['form-group', errors.productkey ? 'has-error' : '']">
                        <input type="text" name="productkey" class="form-control" :placeholder="t_productkey + ': XXXXX-XXXXX-XXXXX-XXXXXX-XXXXXX'" required v-model="form.productkey">
                        <span v-if="errors.productkey" class="help-block animated fadeInUp">
                            <strong>{{ errors.productkey[0] }}</strong>
                        </span>
                    </div>
                </div>
                <div v-else-if="mode==='delete'" class="modal-body text-center scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <template v-for="license in this.licenses">
                        <div class="block m-b-sm">{{ license.productkey }}</div>
                    </template>
                </div>
                <div class="modal-footer">
                    <v-btn v-if="mode==='add'" type="button" class="btn btn-primary"
                            @click.stop.prevent="add_license()">
                        {{ t_add }}
                    </v-btn>
                    <v-btn v-if="mode==='add-new-project'" type="button" class="btn btn-primary"
                            @click.stop.prevent="add_license_new_project()">
                        {{ t_add }}
                    </v-btn>
                    <v-btn v-if="mode==='add-new-or-connect-project'" type="button" class="btn btn-primary"
                            @click.stop.prevent="add_license_new_or_connect_project()">
                        {{ t_add }}
                    </v-btn>
                    <v-btn v-else-if="mode==='delete'" type="button" class="btn btn-primary"
                            @click.stop.prevent="delete_licenses()">
                        {{ t_delete }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-secondary" @click.stop.prevent="cancel()">
                        {{ t_cancel }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin"
    import toaster from "../../common/toaster";

    export default {
        mixins: [
            modalMixin
        ],
        components: {
            text255: require('../dynamic_fields/text255.vue').default,
            float: require('../dynamic_fields/float.vue').default,
            bool: require('../dynamic_fields/bool.vue').default,
            date: require('../dynamic_fields/date.vue').default,
            fileupload: require('../dynamic_fields/fileupload.vue').default
        },
        data() {
            return {
                t_close: Lang.langGet("Close"),
                t_new: Lang.langGet("Add new license"),
                t_new_project: Lang.langGet("Create project from license"),
                t_new_or_connect_project: Lang.langGet("Create or connect project using product key"),
                t_remove: Lang.langGet("Remove license"),

                t_add_fail: Lang.langGet("License could not be added."),
                t_add_success: Lang.langGet("License added successfully."),
                t_delete_fail: Lang.langGet("Licenses could not be removed."),
                t_delete_success: Lang.langGet("Licenses removed succssfully."),

                t_cancel: Lang.langGet("Cancel"),
                t_add: Lang.langGet("Add"),
                t_save: Lang.langGet("Save"),
                t_delete: Lang.langGet("Confirm"),
                t_edit_license: Lang.langGet("Edit"),
                t_productkey: Lang.langGet("Product Key"),

                licenses: {},
                mode: 'add',
                ssoOverride: false,
                form: {
                    productkey: ''
                },
                project_id: Laravel.activeProject,
                errors: {},

                modalName: 'edit-license',
            }
        },
        methods: {
            add_license: function() {
                axios.post('license/add', {
                    project_id: Laravel.activeProject,
                    productkey: this.form.productkey
                }).then(() => {
                    toaster.success(this.t_add_success);
                    this.errors = {};
                    location.reload();
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    this.errors = error.response.data.errors;
                    toaster.error(this.t_add_fail);
                });
            },
            add_license_new_project: function () {
                axios.post('license/add', {
                    project_id: null,
                    productkey: this.form.productkey
                }).then(() => {
                    toaster.success(this.t_add_success);
                    this.errors = {};
                    location.reload();
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    this.errors = error.response.data.errors;
                    toaster.error(this.t_add_fail);
                });
            },
            add_license_new_or_connect_project: function () {
                axios.post('project-selection/add', {
                    project_id: null,
                    productkey: this.form.productkey,
                    sso_add_project: this.ssoOverride,
                }).then((response) => {
                    toaster.success(this.t_add_success);
                    this.errors = {};
                    if (response.data.total === 1) {
                        window.location = '/';
                    } else {
                        location.reload();
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    this.errors = error.response.data.errors;
                    toaster.error(this.t_add_fail);
                });
            },
            delete_licenses: function () {
                axios.post('license/delete', {
                    project_id: Laravel.activeProject,
                    licenses: this.licenses
                }).then(() => {
                    toaster.success(this.t_delete_success);
                    this.errors = {};
                    location.reload();
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    this.errors = error.response.data.errors;

                    toaster.error(this.t_delete_fail);
                });
            },
            cancel: function () {
                this.errors = {};
                this.licenses = {};
                this.form = {
                    productkey: ''
                };
                EaseEventBus.fire('hideModal', this.modalName);
            },
        },
        mounted() {
            EaseEventBus.listen('modifyMode', (data) => {
                this.mode = data.mode;

                if (data.mode === 'delete') {
                    this.licenses = data.licenses;
                } else if (data.mode === 'add-new-or-connect-project') {
                    this.ssoOverride = data.ssoOverride;
                }
            });
        },
    }
</script>
